import React from "react";
import { Link } from "react-router-dom";
import CardHeader from "./CardHeader";
import DataTableSearch from "./DataTableSearch";
import AddButton from "./AddButton";
import HeaderContent from "./HeaderContent";
import DataTable from "react-data-table-component";
import guLocale from "../locales/gu";

const HeadListing = ({
  columns,
  data,
  filterText,
  handleFilterChange,
  handleShow,
  totalCashBalance,
  totalBankBalance,
}) => {
  const locale = guLocale.headListing;
  const localeGlobal = guLocale.global;
  const paginationComponentOptions = {
    rowsPerPageText: localeGlobal.rowsPerPageText, // Gujarati text for "Rows per page"
    rangeSeparatorText: localeGlobal.rangeSeparatorText, // Gujarati text for "of"
    selectAllRowsItem: true,
    selectAllRowsItemText: localeGlobal.selectAllRowsItemText, // Gujarati text for "All"
  };
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">{locale.title}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">{locale.homeBreadcrumb}</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {locale.headsBreadcrumb}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="custom-callout custom-callout-warning">
                    <i className="fas fa-info-circle" style={{ fontSize: '1.3em' }}></i> <span className="mr-1">{locale.noteLabel}:</span>{locale.noteDescription}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{totalCashBalance}</h3>
                    <p>{locale.openingBalanceCash}</p>
                  </div>
                  <div className="icon">
                    <i className="fa fa-coins custom-ion-icon"/>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{totalBankBalance}</h3>
                    <p>{locale.openingBalanceBank}</p>
                  </div>
                  <div className="icon">
                    <i className="fa fa-university custom-ion-icon"/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <CardHeader className="card-header">
                    <HeaderContent>
                      <DataTableSearch
                        filterText={filterText}
                        handleFilterChange={handleFilterChange}
                      />
                    </HeaderContent>
                    <AddButton
                      onClick={handleShow}
                      text={locale.addHeadButtonText}
                    />{" "}
                    {/* Add Head */}
                  </CardHeader>
                  <div className="card-body">
                    <DataTable
                      pagination
                      columns={columns}
                      data={data} // Use filteredData here
                      noDataComponent={localeGlobal.noRecordsToDisplayLabel}
                      paginationComponentOptions={paginationComponentOptions}
                      highlightOnHover
                      striped
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HeadListing;
